import { useQuery } from 'react-query';

import { useCompany } from 'modules/app/hooks/useCompany';
import { type ApprovalWorkflow } from 'src/core/modules/approval-by-dimensions/approvalWorkflow';

const fetchActiveApprovalWorkflow = async (companyId: string) =>
  fetch(`${appConfig.apiUrls.apiV2}/${companyId}/approval-workflows/active`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
    },
  });

export const useApprovalWorkflowQuery = ({ enabled }: { enabled: boolean }) => {
  const company = useCompany();
  return useQuery(
    ['approval-workflows', 'active'],
    async (): Promise<ApprovalWorkflow> => {
      const response = await fetchActiveApprovalWorkflow(company.id);
      if (!response.ok) {
        throw new Error('Failed to fetch approval workflow');
      }
      return response.json();
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      refetchInterval: 5000,
      refetchIntervalInBackground: true,
      enabled,
    },
  );
};
